var _filter, _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgS1169Ele(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1080,
    viewBox: "0 0 1920 1080",
    width: 1920,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 306.546,
    width: 1639.55,
    x: -34.2731,
    y: 791.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.17361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.6366
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.494118 0 0 0 0 0.694118 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2747_160877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2747_160877",
    mode: "normal",
    result: "shape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1920v1080h-1920z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fae9f2",
    height: 172,
    rx: 62.6863,
    width: 1505,
    x: 33,
    y: 850
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ea0d8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89.35 871.296c-6.1868.12-10.6244-3.864-10.7426-9.967-.0815-4.214 1.2318-9.037 5.2729-18.273l5.1153-11.874c.405-.88 1.2374-1.477 2.2217-1.496l6.8898-.134c1.2655-.024 1.9859.834 1.5889 2.15l-6.0884 19.742c3.6868 1.528 6.1447 4.969 6.229 9.328.1153 5.958-4.1592 10.402-10.4866 10.524zm26.856-.519c-6.186.119-10.624-3.865-10.742-9.968-.082-4.214 1.232-9.037 5.273-18.273l5.115-11.873c.405-.881 1.237-1.478 2.222-1.497l6.889-.133c1.266-.025 1.986.833 1.589 2.149l-6.088 19.742c3.687 1.528 6.145 4.969 6.229 9.329.115 5.957-4.159 10.401-10.487 10.524z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1519.33 997.809c6.19-.12 10.63 3.861 10.74 9.971.09 4.21-1.23 9.03-5.27 18.27l-5.11 11.87c-.41.88-1.24 1.48-2.23 1.5l-6.89.13c-1.26.03-1.98-.83-1.58-2.15l6.08-19.74c-3.68-1.53-6.14-4.97-6.22-9.33-.12-5.95 4.15-10.398 10.48-10.521zm-26.85.52c6.18-.12 10.62 3.861 10.74 9.971.08 4.21-1.23 9.03-5.28 18.27l-5.11 11.87c-.41.88-1.24 1.48-2.22 1.5l-6.89.13c-1.27.03-1.99-.83-1.59-2.15l6.09-19.74c-3.69-1.53-6.15-4.97-6.23-9.33-.12-5.95 4.16-10.399 10.49-10.521z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1169Ele);
export default __webpack_public_path__ + "static/media/S1_16_9_ELE.418e1bfe9ca24dff18955a5ca2e1b710.svg";
export { ForwardRef as ReactComponent };